import axios from "axios"
import { authInstanceAxios } from "config"
const subURL = "user"

export const getUser = () => {
    let user = localStorage.getItem("user")
    if (user) {
        user = JSON.parse(user)
        return { user: user.user, jwt: user.jwt }
    } else {
        return null
    }
}

export const fetchCurrentUser = () => {
    const { jwt } = getUser();
    return axios.get(`/${subURL}`, { headers: { "Authorization": jwt } })
        .then(response => {
            return response.data
        })
        .catch(err => {
            throw err
        })
}

export const updateCurrentUser = (updatedUser) => {
    const { jwt } = getUser();
    return axios.put(`/${subURL}`, updatedUser, { headers: { "Authorization": jwt } })
        .then(response => {
            return response.data
        })
        .catch(err => {
            throw err
        })
}